import React, { SVGProps } from 'react';
import { ReactComponent as UK } from './uk.svg'

const SvgCustomUk = (props: SVGProps<SVGSVGElement>) => (
	<UK></UK>
);

export default SvgCustomUk;
